module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.group.length === 0) ? _c('div', {
    staticClass: "empty-container"
  }, [_c('div', {
    on: {
      "click": _vm.handleToggleCollapse
    }
  }, [_vm._v("Expand to add media questions")])]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "hook-container",
    attrs: {
      "group": "hooks",
      "draggable": ".draggable"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleCollapse($event)
      }
    }
  }, _vm._l((_vm.value.group), function(question) {
    return _c('div', {
      key: question.id,
      staticClass: "hook-item draggable"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(question.mediaClip.title))]), _vm._v(" "), _c('div', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(question.mediaClip.artist))])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffa9ff70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/music/MusicEditorCollapsed.vue
// module id = 3432
// module chunks = 3